import type { Nullable } from "vite-node"
import type { TileGraphNode } from "../../../../core/engine/TileGraphNode/TileGraphNode.type"
import type { EntityId } from "../../../../core/entity/EntityId.type"
import type { Entity } from "../../../../core/entity/index"
import { next } from "../../../../core/rng/index"
import tmpRngWith from "../../../../core/rng/tmpRngWith"
import isEntityWithGrassWaves from "./isEntityWithGrassWaves"

export default function grassWaveEntitySecondChance(
  node1: Nullable<TileGraphNode>,
  indexSet: Set<number>,
  shoalEntId: EntityId,
  grassEntIdList: Array<EntityId>,
  grassEntList: Array<Entity>,
  distanceToLandList: Int16Array,
): void {
  if (node1) {
    const index1 = node1.index
    if (!indexSet.has(index1)) {
      const grassEnt1 = node1.ents().find(isEntityWithGrassWaves)
      if (grassEnt1) {
        const grassEnt1Id = grassEnt1.id
        const distanceToLand = distanceToLandList[index1] || 0
        const probability = (1 / ((distanceToLand * 1.1) + 0.01))

        if (grassEnt1Id && next(tmpRngWith(shoalEntId + grassEnt1Id)) < probability) {
          indexSet.add(index1)
          grassEntIdList.push(grassEnt1Id)
          grassEntList.push(grassEnt1)
        }
      }
    }
  }
}